import React, { useEffect, useState } from 'react';
import { CommonLabeledTextAreaProps } from '../../../types/common';
import ErrorLabel from '../ErrorLabel';
import InnerLabel from '../InnerLabel';

const LabeledTextArea: React.FC<CommonLabeledTextAreaProps> = ({
  label,
  name,
  register,
  errors,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  disabled,
  defaultValue,
  maxlength,
  errorLabel,
  labelClassName = '',
  inputClassName = '',
  inputTestId = '',
  height = 5,
  width = 50,
  ...otherProps
}: CommonLabeledTextAreaProps) => {
  const [showAsPlaceholder, setShowAsPlaceholder] = useState(!defaultValue);

  const handleOnFocus = (e: React.FocusEvent<HTMLTextAreaElement>): void => {
    e.persist();
    setShowAsPlaceholder(false);
    onFocus?.(e);
  };
  const handleOnBlur = (e: React.FocusEvent<HTMLTextAreaElement>): void => {
    e.persist();
    setShowAsPlaceholder(!e.target.value || e.target.value === '');
    onBlur?.(e);
  };

  useEffect(() => {
    setShowAsPlaceholder(!defaultValue || defaultValue === '');
  }, [setShowAsPlaceholder, defaultValue]);

  return (
    <div className="textarea">
      <div className="mt-2">
        <div className="mt-1.5 relative text-left rounded-md border checkout-panel-form-input">
          <InnerLabel
            inputName={name}
            hasErrors={!!errorLabel}
            className={labelClassName}
            showAsPlaceholder={showAsPlaceholder}
          >
            {label}
          </InnerLabel>
          <textarea
            id={name}
            className={`${inputClassName} appearance-none block w-full pl-3 pr-3 pb-1 ml-0 rounded-md checkout-panel-form-input focus:outline-none
                    ${errors ? 'border-red-600' : ''}
                    ${disabled && 'opacity-50 cursor-not-allowed'}
                    transition duration-150 ease-in-out sm:text-sm sm:leading-5`}
            rows={height}
            cols={width}
            maxLength={maxlength}
            defaultValue={defaultValue}
            ref={register}
            name={name}
            disabled={disabled}
            onBlur={handleOnBlur}
            onKeyDown={onKeyDown}
            onFocus={handleOnFocus}
            onChange={onChange}
            data-testid={inputTestId}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...otherProps}
          />
          <ErrorLabel>{errorLabel}</ErrorLabel>
        </div>
      </div>
    </div>
  );
};
export default LabeledTextArea;
